import {ExamStatus, MappedExamStatuses} from 'components';
import { Color, ColorStatus } from '_helpers';

export const NeedingAttentionMappedExamStatuses = {
    ...MappedExamStatuses,
    [ExamStatus.AwaitingExpertConfirmation as string]: new ColorStatus(Color.Orange, 'Подтвердите участие'),
    [ExamStatus.Finished as string]: new ColorStatus(Color.Orange, 'Написать рекомендации'),
    [ExamStatus.FinalizedResults as string]: new ColorStatus(Color.Orange, 'Подписать протокол НОК'),
    [ExamStatus.NokProtocolSigned as string]: new ColorStatus(Color.Orange, 'Подписать протокол АК'),
    [ExamStatus.AkProtocolSigned as string]: new ColorStatus(Color.Orange, 'Подписать решение Совета'),
    [ExamStatus.SovietProtocolSignedByMembers as string]: new ColorStatus(Color.Orange, 'Подписать решение Совета'),
};
